import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { useNotifications } from '../../data/hooks/notifications/useNotifications';
import ListItem from '../elements/DEPRECATED_ListItem';
import Link from '../elements/Link';
import { getNotificationIconSrc } from '../elements/NotificationIcon';
import ScreenTitle from '../elements/ScreenTitle/ScreenTitle';
import Scrollable from '../elements/Scrollable';
import TopBar from '../elements/TopBar/TopBar';
import WaitWhileBusy from '../WaitWhileBusy';
import Screen from './Screen';

class NotificationsScreen extends React.Component {
    render() {
        let { i18n } = this.props,
            header = (
                <div>
                    <TopBar returnURL="/" />
                    <ScreenTitle
                        screen={i18n['label.Notifications']}
                        menu={[
                            <Link
                                href="#"
                                onClick={this.handleMarkAllAsRead.bind(this)}
                            >
                                {i18n['notifications.mark.all.as.read']}
                            </Link>,
                        ]}
                    />
                </div>
            ),
            notifications;

        if (this.props.notifications.length) {
            notifications = (
                <ul className="list">
                    {this.props.notifications.map((notif) => {
                        let eventId = _.get(notif, 'content.data.eventId'),
                            event = this.props.events[eventId] || {},
                            itemProps = {
                                iconColor: _.get(
                                    event,
                                    'event.settings.primary_color'
                                ),
                                tagName: 'div',
                                icon: getNotificationIconSrc(notif),
                            };

                        let title = _.isString(notif.content.message)
                            ? notif.content.message
                            : notif.content.message[this.props.locale] ||
                              notif.content.message['en'];

                        return (
                            <li
                                key={notif.id}
                                className={notif.read ? 'read' : 'unread'}
                            >
                                <Link href={'./' + notif.id}>
                                    <ListItem
                                        {...itemProps}
                                        iconSmall="iconSmall"
                                        next
                                    >
                                        <p className="text">
                                            {_.get(event, 'event.name')}
                                        </p>
                                        <p className="text name">
                                            {!notif.read ? (
                                                <b>{title}</b>
                                            ) : (
                                                title
                                            )}
                                        </p>
                                        <p className="text">
                                            {moment
                                                .utc(notif.sent_on)
                                                .local()
                                                .format('lll')}
                                        </p>
                                    </ListItem>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            );
        } else {
            notifications = (
                <p className="text-center">
                    <br />
                    <br />
                    <br />
                    {i18n['notifications.empty']}
                    <br />
                    <br />
                    <br />
                </p>
            );
        }

        return (
            <Screen header={header}>
                <Scrollable>{notifications}</Scrollable>
            </Screen>
        );
    }
    handleMarkAllAsRead() {
        this.props.unreadNotifications.forEach((notif) => {
            app.api.notifications.markRead(notif.id);
        });
    }
}

const ConnectedScreen = connect((state, props) => {
    // NOTE: moved notifications to hook in default export to use the same code base used in other places
    return {
        i18n: state.i18n.translations,
        locale: state.i18n.locale,
        events: state.events,
        unreadNotifications: props.notifications.filter((notif) => !notif.read),
    };
})(NotificationsScreen);

export default (props) => {
    const notifications = useNotifications();
    return (
        <WaitWhileBusy>
            <ConnectedScreen
                {...props.match.params}
                notifications={notifications}
            />
        </WaitWhileBusy>
    );
};
